<template>
  <b-overlay
      :show="$store.getters['slsTemplateImagem/getIsLoading']"
      rounded="sm"
  >
    <div class="position-absolute" style="top: -50px;right: 0">
      <b-button variant="outline-primary" class="mr-2" :to="{name: 'template-imagem-list'}">Cancelar</b-button>
      <b-button
          variant="primary"
          @click="handleSubmit"
      >
        Salvar
      </b-button>
    </div>
    <validation-observer ref="refFormCreateTemplateImagem">
      <b-form>
        <b-row>
          <b-col cols="12">
            <b-card>
              <b-card-title class="bg-gray">
                <span>Cadastro de configurações imagens produtos</span>
              </b-card-title>
              <b-row>
                <!-- Tabela: hbi_es_marca -->
                <b-col cols="12" sm="6">
                  <b-form-group label="Marca">
                    <validation-provider
                        #default="{ errors }"
                        name="Marca"
                        rules="required"
                    >
                      <b-form-select
                          v-model="formTemplateImagem.cod_marca"
                          label-field="text"
                          :state="errors.length > 0 ? false:null"
                          value-field="value"
                          :options="$store.getters['slsTemplateImagem/getOptionsMarcas']"
                          @change="changeSelectedMarca($event)"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>

                <!-- Tabela: sls_familia_comercial -->
                <b-col cols="12" sm="6">
                  <b-form-group label="Referência">
                    <validation-provider
                        #default="{ errors }"
                        name="Referência"
                        rules="required"
                    >
                      <v-select
                          id="select-referencia"
                          name="select-referencia"
                          v-model="formTemplateImagem.familia_comercial"
                          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                          :class="{ 'border-danger border-round': errors.length > 0 }"
                          :options="$store.getters['slsTemplateImagem/getOptionsReferencias']"
                          label="descricao"
                          key="descricao"
                          :disabled="formTemplateImagem.cod_marca === null"
                          :loading="$store.getters['slsTemplateImagem/getIsLoading']"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>

                <b-col cols="12">
                  <b-form-group label="Descrição">
                    <validation-provider
                        #default="{ errors }"
                        name="Descrição"
                        rules="required"
                    >
                      <b-form-textarea
                          id="textarea-descricao"
                          placeholder="Descrição"
                          :state="errors.length > 0 ? false:null"
                          v-model="formTemplateImagem.descricao"
                          rows="3"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col cols="12" class="mt-2">
                  <b-form-group label="Característica">
                    <validation-provider
                        #default="{ errors }"
                        name="Característica"
                        rules="required"
                    >
                      <b-form-textarea
                          v-model="formTemplateImagem.caracteristica"
                          :state="errors.length > 0 ? false:null"
                          id="textarea-caracteristica"
                          placeholder="Característica"
                          rows="3"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>

                <b-col cols="12" class="mt-2">
                  <b-form-group label="Composição">
                    <validation-provider
                        #default="{ errors }"
                        name="Composição"
                        rules="required"
                    >
                  <b-form-textarea
                      v-model="formTemplateImagem.composicao"
                      :state="errors.length > 0 ? false:null"
                      id="textarea-composicao"
                      placeholder="Composição"
                      rows="3"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                  </b-form-group>
                </b-col>

                <b-col cols="12" class="mt-2">
                  <b-form-group label="Benefícios">
                    <validation-provider
                        #default="{ errors }"
                        name="Benefícios"
                        rules="required"
                    >
                      <b-form-textarea
                          v-model="formTemplateImagem.beneficios"
                          :state="errors.length > 0 ? false:null"
                          id="textarea-beneficios"
                          placeholder="Benefícios"
                          rows="3"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>

                <b-col cols="12" class="mt-2">
                  <b-form-group label="Indicações">
                    <validation-provider
                        #default="{ errors }"
                        name="Indicações"
                        rules="required"
                    >
                  <b-form-textarea
                      v-model="formTemplateImagem.indicacoes"
                      :state="errors.length > 0 ? false:null"
                      id="textarea-indicacoes"
                      placeholder="Indicações"
                      rows="3"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-card>
          </b-col>

          <b-col cols="12">
            <b-card>
              <b-card-title class="d-flex justify-content-between">
                <span>Imagens</span>
                <b-button
                    title="Adicionar imagem"
                    v-b-modal.modal-config-imagem
                    variant="outline-primary"
                    class="btn-icon rounded-circle"
                    :disabled="isAbilityButtonAddImg"
                >
                  <feather-icon
                      icon="PlusIcon"
                      size="20"
                  />
                </b-button>
              </b-card-title>
              <b-row class="mb-5">
                <b-table
                    :items="imagensTemplateImagem"
                    :fields="columnsTable"
                    :per-page="paginationImagens.perPage"
                    responsive
                    class="mb-0"
                >
                  <template #cell(caminho)="data">
                      <img
                          :src="data.item.caminho_base64"
                          alt="Imagem"
                          width="100px"
                      >
                  </template>
                  <template #cell(imagem_principal)="data">
                    <b-badge
                        v-if="data.value"
                        variant="success"
                    >
                      Sim
                    </b-badge>
                    <b-badge
                        v-else
                        variant="danger"
                    >
                      Não
                    </b-badge>
                  </template>
                  <template #cell(actions)="data">
                    <div class="d-flex">
                      <b-button
                          v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                          title="Visualizar"
                          v-b-modal.modal-config-imagem
                          @click="handleAddImagem(data.item)"
                          variant="flat-success"
                          class="btn-icon"
                      >
                        <feather-icon
                            icon="EyeIcon"
                            size="20"
                        />
                      </b-button>

                      <b-button
                          v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                          title="Deletar"
                          variant="flat-danger"
                          @click="formTemplateImagem.imagens.splice(data.index, 1)"
                          class="btn-icon"
                      >
                        <feather-icon
                            icon="TrashIcon"
                            size="20"
                        />
                      </b-button>
                    </div>
                  </template>
                </b-table>
              </b-row>
            </b-card>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>

    <modal-create-configuracao-imagem
        ref="refModalConfigImagem"
        v-model="currentImage"
      :marca-nome="getDesMarca()"
      :familia-descricao="formTemplateImagem.familia_comercial ? formTemplateImagem.familia_comercial.descricao : ''"
        @addImagem="addOrUpdatedImagem($event)"
        @closeModal="resetCurrentImagen()"
    />
  </b-overlay>
</template>

<script>
import {
  required, email, confirmed, url, between, alpha, integer, password, min, digits, alphaDash, length,
} from '@core/utils/validations/validations';
import SlsTemplateImagemService from '@/services/SistemaDKP/sls-template-imagem.service';
import ModalCreateConfiguracaoImagem from '@/views/cadastros/template-imagem/create/ModalCreateConfigImagem.vue';
import { formatDateBr } from '@core/utils/filter';
import { generateId } from '@core/utils/utils';

const SLSTemplateImagemService = new SlsTemplateImagemService();
export default {
  name: 'EditIndex',
  components: {
    ModalCreateConfiguracaoImagem,
  },
  data() {
    return {
      paginationImagens: {
        currentPage: 1,
        perPage: 5,
      },
      required,
      email,
      confirmed,
      url,
      between,
      alpha,
      integer,
      password,
      min,
      digits,
      alphaDash,
      length,
      SLSTemplateImagemService,
      columnsTable: [
        { key: 'caminho', label: 'Imagem', sortable: false },
        { key: 'imagem_principal', label: 'Imagem Principal', sortable: true },
        { key: 'actions', label: 'Ações', sortable: false },
      ],
      currentImage: {
        cdn_cor: null,
        cdn_embalag: null,
        exibe_cores: null,
        des_marca: null,
        imagem_principal: null,
        caminho: null,
        caminho_base64: null,
        caminho_upload: null,
        ordem: null,
      },
    };
  },
  computed: {
    isAbilityButtonAddImg() {
      return this.$store.getters['slsTemplateImagem/getIsValidCurrentCofigImagem'];
    },
    formTemplateImagem: {
      get() {
        return this.$store.getters['slsTemplateImagem/getCurrentTemplateImagem'];
      },
      set(value) {
        this.$store.commit('slsTemplateImagem/setCurrentTemplateImagem', value);
      },
    },
    imagensTemplateImagem: {
      get() {
        return this.$store.getters['slsTemplateImagem/getImagensCurrentTemplateImagem'];
      },
      set(value) {
        this.$store.commit('slsTemplateImagem/setImagensCurrentTemplateImagem', value);
      },
    },
  },
  methods: {
    handleAddImagem(item) {
      this.currentImage = {
        ...item,
        des_marca: this.getDesMarca(),
      };
    },
    changeSelectedMarca() {
      // this.formTemplateImagem.familia_comercial = {
      //   familia_comercial_id: null,
      //   descricao: "Selecione uma referência",
      //   disabled: true
      // };
      SLSTemplateImagemService.loadFamiliaComercial(this.formTemplateImagem.cod_marca);
      this.currentImage.des_marca = this.getDesMarca();
    },
    getDesMarca() {
      return this.$store.getters['slsTemplateImagem/getOptionsMarcas'].find((m) => m.value === this.formTemplateImagem.cod_marca).text;
    },
    handleSubmit() {
      this.$refs.refFormCreateTemplateImagem.validate().then(async (valid) => {
        if (valid) {
          await SLSTemplateImagemService.create(this.formTemplateImagem);
          await this.$refs.refFormCreateTemplateImagem.reset();
          await this.$router.push({ name: 'template-imagem-list' });
        }
      });
    },
    changeImg(event, nameVar) {
      const file = event.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.imagemPresenter[nameVar] = e.target.result;
        };
        reader.readAsDataURL(file);
      }
    },
    addOrUpdatedImagem(imagem) {
      const index = this.formTemplateImagem.imagens.findIndex((item) => item.id === imagem.id);
      if (index !== -1) {
        this.$store.commit('slsTemplateImagem/updateImagem', { index, imagem });
      } else {
        this.$store.commit('slsTemplateImagem/addImagem', {
          id: generateId(),
          ...imagem,
        });
      }
      this.resetCurrentImagen();
    },
    resetCurrentImagen() {
      this.currentImage = {
        cdn_cor: null,
        cdn_embalag: null,
        exibe_cores: null,
        des_marca: null,
        imagem_principal: null,
        caminho: null,
        caminho_base64: null,
        caminho_upload: null,
        ordem: null,
      };
    },
  },
  async mounted() {
    await SLSTemplateImagemService.loadRecursos();
    await this.$refs.refFormCreateTemplateImagem.reset();
    this.$store.dispatch('slsTemplateImagem/resetFields');
  },
};
</script>

<style scoped lang="scss">
.molde-img {
  border: 2px solid #ccc;
  display: flex;
  justify-content: center;

  img {
    padding: 10px;
    height: 100%;
    width: 100%;
  }
}

.box-img-empty {
  border: 2px solid #ccc;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 300px;
  width: 400px;

  img {
    padding: 10px;
    max-height: 300px;
  }
}

.box-img-empty-primary-secondary {
  border: 2px solid #ccc;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100px;
  width: 250px;

  img {
    padding: 10px;
    max-height: 100px;
    max-width: 250px;
  }
}

</style>
